import { DepartmentOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export function filterDepartmentOption(
   types: DepartmentOption[],
   searchText: string | null | undefined
): DepartmentOption[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return item?.name?.toString().includes(upper) || item?.name?.toUpperCase().includes(upper);
      });
   } else {
      return types || [];
   }
}
